import React from 'react';
import { globalData } from './data';
import './Styles/Global.scss';
import {IoIosArrowRoundForward} from 'react-icons/io';
import {GiWaterDrop} from 'react-icons/gi';
const Global=()=>{
    return(
        <div className="global-job">
            <h1>HostDesign is global</h1>
            <p>We help the world securely connect and collaborate from anywhere at any time</p>
            <div className="cards">
                {globalData.map((d) =>{
                    return(
                        <Card {...d} />
                    )
                })}
            </div>
        </div>
    )
};
export default Global ;

export function Card(props){
    return(
        <div className="global-card"  data-aos="zoom-in"
        data-aos-delay={props.delay} style={{ backgroundImage: `url(${props.backgroundImage})` }}>
            <div className="location">
            <p style={{color: `${props.Color}` }}> <GiWaterDrop className="drop"/> {props.location}</p>
            </div>
          <div className="content">
              <p>{props.desc}</p>
              <p className="aftertext">From our HQ in Redwood City to our other hubs such as New York City, Chicago, Austin, and all our remote locations</p>
              <p className="view">View More <IoIosArrowRoundForward className="icon" /> </p>
          </div>
        </div>
    )
};
